import { useQuery } from "@tanstack/react-query";

import { GetSignalResponse } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { queryKeys } from "@/constants";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

interface UseGetSignalArgs {
  userToken: string;
  workspaceId: number;
  signalId: number;
  enabled?: boolean;
}

export const getSignalQueryKey = (workspaceId: number, signalId: number) =>
  [queryKeys.signals, workspaceId, "detail", signalId] as const;

export const useGetSignal = ({
  userToken,
  workspaceId,
  signalId,
  enabled = true,
}: UseGetSignalArgs) =>
  useQuery({
    queryKey: getSignalQueryKey(workspaceId, signalId),
    queryFn: async (): Promise<GetSignalResponse> => {
      const response = await fetch(ENDPOINTS.signals.get(workspaceId, signalId), {
        headers: jsonAuthHeaders(userToken),
      });

      return handleResponse(response);
    },
    enabled: enabled && Boolean(userToken) && workspaceId > 0 && Number.isFinite(signalId),
  });
